// Capture a stable local reference to Lodash before any script can clobber window._
var lodash = window.__lodash || window._;

function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error"),
    $(".map-section__container").remove(),
    $(".map-section__link").remove(),
    $(".map-section__overlay").after(
      '<div class="errors text-center">' + theme.strings.authError + "</div>"
    );
}
(window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function e() {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = lodash.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (e, t) {
      var i = $(e),
        s = i.attr("data-section-id"),
        a = i.attr("data-section-type");
      if (((t = t || this.constructors[a]), !lodash.isUndefined(t))) {
        var o = lodash.assignIn(new t(e), { id: s, type: a, container: e });
        this.instances.push(o);
      }
    },
    _onSectionLoad: function (e) {
      var t = $("[data-section-id]", e.target)[0];
      t && this._createInstance(t);
    },
    _onSectionUnload: function (e) {
      this.instances = lodash.filter(this.instances, function (t) {
        var i = t.id === e.detail.sectionId;
        return i && lodash.isFunction(t.onUnload) && t.onUnload(e), !i;
      });
    },
    _onSelect: function (e) {
      var t = lodash.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !lodash.isUndefined(t) && lodash.isFunction(t.onSelect) && t.onSelect(e);
    },
    _onDeselect: function (e) {
      var t = lodash.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !lodash.isUndefined(t) && lodash.isFunction(t.onDeselect) && t.onDeselect(e);
    },
    _onBlockSelect: function (e) {
      var t = lodash.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !lodash.isUndefined(t) && lodash.isFunction(t.onBlockSelect) && t.onBlockSelect(e);
    },
    _onBlockDeselect: function (e) {
      var t = lodash.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !lodash.isUndefined(t) &&
        lodash.isFunction(t.onBlockDeselect) &&
        t.onBlockDeselect(e);
    },
    register: function (e, t) {
      (this.constructors[e] = t),
        $("[data-section-type=" + e + "]").each(
          function (e, i) {
            this._createInstance(i, t);
          }.bind(this)
        );
    },
  })),
  (window.slate = window.slate || {}),
  (slate.rte = {
    wrapTable: function () {
      $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
      var e = $(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
        ),
        t = e.add(".rte iframe#admin_bar_iframe");
      e.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
      }),
        t.each(function () {
          this.src = this.src;
        });
    },
  }),
  (window.slate = window.slate || {}),
  (slate.a11y = {
    pageLinkFocus: function (e) {
      var t = "js-focus-hidden";
      e.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(t)
        .one("blur", function i() {
          e.first().removeClass(t).removeAttr("tabindex");
        });
    },
    focusHash: function () {
      var e = window.location.hash;
      e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (e) {
          this.pageLinkFocus($(e.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (e) {
      var t = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr("tabindex", "-1"),
        e.$elementToFocus.focus(),
        $(document).off("focusin"),
        $(document).on(t, function (t) {
          e.$container[0] === t.target ||
            e.$container.has(t.target).length ||
            e.$container.focus();
        });
    },
    removeTrapFocus: function (e) {
      var t = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$container &&
        e.$container.length &&
        e.$container.removeAttr("tabindex"),
        $(document).off(t);
    },
  }),
  (theme.Images = {
    preload: function e(t, i) {
      "string" == typeof t && (t = [t]);
      for (var s = 0; s < t.length; s++) {
        var a = t[s];
        this.loadImage(this.getSizedImageUrl(a, i));
      }
    },
    loadImage: function e(t) {
      new Image().src = t;
    },
    switchImage: function e(t, i, s) {
      var a = this.imageSize(i.src),
        o = this.getSizedImageUrl(t.src, a);
      s ? s(o, t, i) : (i.src = o);
    },
    imageSize: function e(t) {
      var i = t.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );
      return null !== i ? i[1] : null;
    },
    getSizedImageUrl: function e(t, i) {
      if (null == i) return t;
      if ("master" === i) return this.removeProtocol(t);
      var s = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != s) {
        var a = t.split(s[0]),
          o = s[0];
        return this.removeProtocol(a[0] + "_" + i + o);
      }
      return null;
    },
    removeProtocol: function e(t) {
      return t.replace(/http(s)?:/, "");
    },
  }),
  (theme.Currency = {
    formatMoney: function e(t, i) {
      "string" == typeof t && (t = t.replace(".", ""));
      var s = "",
        a = /\{\{\s*(\w+)\s*\}\}/,
        o = i || "${{amount}}";
      function n(e, t, i, s) {
        if (
          ((t = t || 2), (i = i || ","), (s = s || "."), isNaN(e) || null == e)
        )
          return 0;
        var a,
          o = (e = (e / 100).toFixed(t)).split(".");
        return (
          o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (o[1] ? s + o[1] : "")
        );
      }
      switch (o.match(a)[1]) {
        case "amount":
          s = n(t, 2);
          break;
        case "amount_no_decimals":
          s = n(t, 0);
          break;
        case "amount_with_comma_separator":
          s = n(t, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = n(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          s = n(t, 0, " ");
      }
      return o.replace(a, s);
    },
  }),
  (slate.Variants = (function () {
    function e(e) {
      (this.$container = e.$container),
        (this.product = e.product),
        (this.singleOptionSelector = e.singleOptionSelector),
        (this.originalSelectorId = e.originalSelectorId),
        (this.enableHistoryState = e.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (e.prototype = lodash.assignIn({}, e.prototype, {
        _getCurrentOptions: function () {
          var e = $(this.singleOptionSelector, this.$container)
            .toArray()
            .map(function (e) {
              var t = $(e),
                i = t.attr("type"),
                s = {};
              return "radio" !== i && "checkbox" !== i
                ? ((s.value = t.val()), (s.index = t.data("index")), s)
                : !!t[0].checked &&
                    ((s.value = t.val()), (s.index = t.data("index")), s);
            })
            .filter(Boolean); // replaces _.compact

          return e;
        },
        _getVariantFromOptions: function () {
          var e = this._getCurrentOptions(),
            t = this.product.variants;
          return t.find(function (t) {
            return e.every(function (e) {
              return t[e.index] === e.value;
            });
          });
        },
        _onSelectChange: function () {
          var e = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant: e }),
            e &&
              (this._updateMasterSelect(e),
              this._updateImages(e),
              this._updatePrice(e),
              this._updateSKU(e),
              (this.currentVariant = e),
              this.enableHistoryState && this._updateHistoryState(e));
        },
        _updateImages: function (e) {
          var t = e.featured_image || {},
            i = this.currentVariant.featured_image || {};
          e.featured_image &&
            t.src !== i.src &&
            this.$container.trigger({ type: "variantImageChange", variant: e });
        },
        _updatePrice: function (e) {
          var t = "Out of stock";
          if (
            ($(".instock-text-init").hide(),
            e.available && null != $(this.originalSelectorId).val())
          ) {
            var i = $(
              this.originalSelectorId + ' option[data-id="' + e.id + '"]'
            ).data("backorder");
            "" != i && void 0 != i
              ? ((t = i),
                $("#AddToCart-product-template").prop("disabled", !0),
                $("#AddToCartText-product-template").text(
                  theme.strings.soldOut
                ))
              : ((t = " "),
                $("#AddToCart-product-template").prop("disabled", !1),
                $("#AddToCartText-product-template").text(
                  theme.strings.addToCart
                )),
              $(".outofstock-text").text(t).show(),
              $(".outofstock-text-init").hide(),
              $(".instock-text").show();
          } else {
            var i = $(
              this.originalSelectorId + ' option[data-id="' + e.id + '"]'
            ).data("backorder");
            (t = "" != i ? i : "Out of stock"),
              $(".outofstock-text").text(t).show(),
              $(".instock-text").hide(),
              $(".outofstock-text-init").hide(),
              $("#AddToCart-product-template").prop("disabled", !0),
              $("#AddToCartText-product-template").text(theme.strings.soldOut);
          }
          (e.price !== this.currentVariant.price ||
            e.compare_at_price !== this.currentVariant.compare_at_price) &&
            this.$container.trigger({ type: "variantPriceChange", variant: e });
        },
        _updateSKU: function (e) {
          e.sku !== this.currentVariant.sku &&
            this.$container.trigger({ type: "variantSKUChange", variant: e });
        },
        _updateHistoryState: function (e) {
          if (history.replaceState && e) {
            var t =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              e.id;
            window.history.replaceState({ path: t }, "", t);
          }
        },
        _updateMasterSelect: function (e) {
          $(this.originalSelectorId, this.$container[0]).val(e.id);
        },
      })),
      e
    );
  })()),
  (theme.Drawers = (function () {
    function e(e, t, i) {
      if (
        ((this.nodes = {
          $parent: $("html").add("body"),
          $page: $("#PageContainer"),
        }),
        (this.config = $.extend(
          {
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + t,
            openClass: "js-drawer-open",
            dirOpenClass: "js-drawer-open-" + t,
          },
          i
        )),
        (this.position = t),
        (this.$drawer = $("#" + e)),
        !this.$drawer.length)
      )
        return !1;
      (this.drawerIsOpen = !1), this.init();
    }
    return (
      (e.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this)),
          this.$drawer.on(
            "click",
            this.config.close,
            $.proxy(this.close, this)
          );
      }),
      (e.prototype.open = function (e) {
        var t = !1;
        return (e ? e.preventDefault() : (t = !0),
        e &&
          e.stopPropagation &&
          (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))),
        this.drawerIsOpen && !t)
          ? this.close()
          : (this.$drawer.prepareTransition(),
            this.nodes.$parent.addClass(
              this.config.openClass + " " + this.config.dirOpenClass
            ),
            (this.drawerIsOpen = !0),
            slate.a11y.trapFocus({
              $container: this.$drawer,
              namespace: "drawer_focus",
            }),
            this.config.onDrawerOpen &&
              "function" == typeof this.config.onDrawerOpen &&
              !t &&
              this.config.onDrawerOpen(),
            this.$activeSource &&
              this.$activeSource.attr("aria-expanded") &&
              this.$activeSource.attr("aria-expanded", "true"),
            this.bindEvents(),
            this);
      }),
      (e.prototype.close = function () {
        this.drawerIsOpen &&
          ($(document.activeElement).trigger("blur"),
          this.$drawer.prepareTransition(),
          this.nodes.$parent.removeClass(
            this.config.dirOpenClass + " " + this.config.openClass
          ),
          (this.drawerIsOpen = !1),
          slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus",
          }),
          this.unbindEvents());
      }),
      (e.prototype.bindEvents = function () {
        this.nodes.$parent.on(
          "keyup.drawer",
          $.proxy(function (e) {
            return 27 !== e.keyCode || (this.close(), !1);
          }, this)
        ),
          this.nodes.$page.on("touchmove.drawer", function () {
            return !1;
          }),
          this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
              return this.close(), !1;
            }, this)
          );
      }),
      (e.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
      }),
      e
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Header = (function () {
    var e = {
        body: "body",
        navigation: "#AccessibleNav",
        siteNavHasDropdown: ".site-nav--has-dropdown",
        siteNavChildLinks: ".site-nav__child-link",
        siteNavActiveDropdown: ".site-nav--active-dropdown",
        siteNavLinkMain: ".site-nav__link--main",
        siteNavChildLink: ".site-nav__link--last",
      },
      t = {
        activeClass: "site-nav--active-dropdown",
        childLinkClass: "site-nav__child-link",
      },
      i = {};
    function s(s) {
      s.find(e.siteNavLinkMain).attr("aria-expanded", "false"),
        s.removeClass(t.activeClass),
        (i.$activeDropdown = $(e.siteNavActiveDropdown)),
        $(e.body).off("click.siteNav"),
        $(window).off("keyup.siteNav");
    }
    return {
      init: function a() {
        (i = {
          $nav: $(e.navigation),
          $topLevel: $(e.siteNavLinkMain),
          $parents: $(e.navigation).find(e.siteNavHasDropdown),
          $subMenuLinks: $(e.siteNavChildLinks),
          $activeDropdown: $(e.siteNavActiveDropdown),
        }),
          i.$parents.on("click.siteNav", function (a) {
            var o,
              n = $(this);
            n.hasClass(t.activeClass) || a.stopImmediatePropagation(),
              (o = n).addClass(t.activeClass),
              i.$activeDropdown.length && s(i.$activeDropdown),
              (i.$activeDropdown = o),
              o.find(e.siteNavLinkMain).attr("aria-expanded", "true"),
              setTimeout(function () {
                $(window).on("keyup.siteNav", function (e) {
                  27 === e.keyCode && s(o);
                }),
                  $(e.body).on("click.siteNav", function () {
                    s(o);
                  });
              }, 250);
          }),
          $(e.siteNavChildLink).on("focusout.siteNav", function () {
            setTimeout(function () {
              !$(document.activeElement).hasClass(t.childLinkClass) &&
                i.$activeDropdown.length &&
                s(i.$activeDropdown);
            });
          }),
          i.$topLevel.on("focus.siteNav", function () {
            i.$activeDropdown.length && s(i.$activeDropdown);
          }),
          i.$subMenuLinks.on("click.siteNav", function (e) {
            e.stopImmediatePropagation();
          });
      },
      unload: function t() {
        $(window).off(".siteNav"),
          i.$parents.off(".siteNav"),
          i.$subMenuLinks.off(".siteNav"),
          i.$topLevel.off(".siteNav"),
          $(e.siteNavChildLink).off(".siteNav"),
          $(e.body).off(".siteNav");
      },
    };
  })()),
  (window.theme = window.theme || {}),
  (theme.MobileNav = (function () {
    var e,
      t,
      i,
      s = {
        mobileNavOpenIcon: "mobile-nav--open",
        mobileNavCloseIcon: "mobile-nav--close",
        subNavLink: "mobile-nav__sublist-link",
        return: "mobile-nav__return-btn",
        subNavActive: "is-active",
        subNavClosing: "is-closing",
        navOpen: "js-menu--is-open",
        subNavShowing: "sub-nav--is-open",
        thirdNavShowing: "third-nav--is-open",
        subNavToggleBtn: "js-toggle-submenu",
      },
      a = {},
      o = 1;
    function n() {
      var e;
      a.$mobileNavToggle.hasClass(s.mobileNavCloseIcon)
        ? r()
        : ((e = a.$siteHeader.outerHeight() + a.$siteHeader.offset().top),
          a.$mobileNavContainer.prepareTransition().addClass(s.navOpen),
          a.$mobileNavContainer.css({
            transform: "translate3d(0, " + e + "px, 0)",
          }),
          a.$pageContainer.css({
            transform:
              "translate3d(0, " +
              a.$mobileNavContainer[0].scrollHeight +
              "px, 0)",
          }),
          slate.a11y.trapFocus({
            $container: a.$mobileNav,
            namespace: "navFocus",
          }),
          a.$mobileNavToggle
            .addClass(s.mobileNavCloseIcon)
            .removeClass(s.mobileNavOpenIcon),
          $(window).on("keyup.mobileNav", function (e) {
            27 === e.which && r();
          }));
    }
    function r() {
      a.$mobileNavContainer.prepareTransition().removeClass(s.navOpen),
        a.$mobileNavContainer.css({ transform: "translate3d(0, -100%, 0)" }),
        a.$pageContainer.removeAttr("style"),
        a.$mobileNavContainer.one(
          "TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",
          function () {
            slate.a11y.removeTrapFocus({
              $container: a.$mobileNav,
              namespace: "navFocus",
            });
          }
        ),
        a.$mobileNavToggle
          .addClass(s.mobileNavOpenIcon)
          .removeClass(s.mobileNavCloseIcon),
        $(window).off("keyup.mobileNav");
    }
    function c(n) {
      if (!e) {
        var r,
          c,
          d,
          l,
          u,
          h,
          p = $(n.currentTarget);
        (e = !0),
          p.hasClass(s.return)
            ? ($(
                "." + s.subNavToggleBtn + '[data-level="' + (o - 1) + '"]'
              ).removeClass(s.subNavActive),
              i && i.length && i.removeClass(s.subNavActive))
            : p.addClass(s.subNavActive),
          (i = p),
          (o = (d = (c = p.data("target"))
            ? $('.mobile-nav__dropdown[data-parent="' + c + '"]')
            : a.$mobileNav).data("level")
            ? d.data("level")
            : 1),
          t && t.length && t.prepareTransition().addClass(s.subNavClosing),
          (t = d),
          (l = c ? d.find("." + s.subNavLink + ":first") : i),
          (u = d[0].scrollHeight),
          c || (u = d.outerHeight()),
          (h = o > 2 ? s.thirdNavShowing : s.subNavShowing),
          a.$mobileNavContainer
            .css("height", u)
            .removeClass(s.thirdNavShowing)
            .addClass(h),
          c ||
            a.$mobileNavContainer
              .removeClass(s.thirdNavShowing)
              .removeClass(s.subNavShowing),
          a.$mobileNavContainer.one(
            "TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",
            function () {
              slate.a11y.trapFocus({
                $container: d,
                $elementToFocus: l,
                namespace: "subNavFocus",
              }),
                a.$mobileNavContainer.off(".subnavToggle"),
                (e = !1);
            }
          ),
          a.$pageContainer.css({ transform: "translate3d(0, " + u + "px, 0)" }),
          t.removeClass(s.subNavClosing);
      }
    }
    return {
      init: function e() {
        (a = {
          $pageContainer: $("#PageContainer"),
          $siteHeader: $(".site-header"),
          $mobileNavToggle: $(".js-mobile-nav-toggle"),
          $mobileNavContainer: $(".mobile-nav-wrapper--"),
          $mobileNav: $("#MobileNav"),
          $subNavToggleBtn: $("." + s.subNavToggleBtn),
        }),
          a.$mobileNavToggle.on("click", n),
          a.$subNavToggleBtn.on("click.subNav", c),
          enquire.register("screen and (max-width: 749px)", {
            unmatch: function () {
              r();
            },
          });
      },
      closeMobileNav: r,
    };
  })(jQuery)),
  (window.theme = window.theme || {}),
  (theme.Search = (function () {
    var e = {
        search: ".search",
        searchSubmit: ".search__submit",
        searchInput: ".search__input",
        siteHeader: ".site-header",
        siteHeaderSearchToggle: ".site-header__search-toggle",
        siteHeaderSearch: ".site-header__search",
        searchDrawer: ".search-bar",
        searchDrawerInput: ".search-bar__input",
        searchHeader: ".search-header",
        searchHeaderInput: ".search-header__input",
        searchHeaderSubmit: ".search-header__submit",
        mobileNavWrapper: ".mobile-nav-wrapper",
      },
      t = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
    function i() {
      s($(e.searchDrawerInput)),
        $(e.mobileNavWrapper).hasClass(t.mobileNavIsOpen) &&
          theme.MobileNav.closeMobileNav();
    }
    function s(e) {
      e.focus(), e[0].setSelectionRange(0, e[0].value.length);
    }
    return {
      init: function a() {
        $(e.siteHeader).length &&
          ($("#PageContainer").addClass("drawer-page-content"),
          $(".js-drawer-open-top")
            .attr("aria-controls", "SearchDrawer")
            .attr("aria-expanded", "false"),
          (theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
            onDrawerOpen: i,
          })),
          $(e.searchSubmit).on("click", function (t) {
            var i = $(t.target).parents(e.search).find(e.searchInput);
            0 === i.val().length && (t.preventDefault(), s(i));
          }),
          $(e.searchHeaderInput)
            .add(e.searchHeaderSubmit)
            .on("focus blur", function () {
              $(e.searchHeader).toggleClass(t.focus);
            }),
          $(e.siteHeaderSearchToggle).on("click", function () {
            var t = $(e.siteHeader).outerHeight(),
              i = $(e.siteHeader).offset().top - t;
            $(e.searchDrawer).css({ height: t + "px", top: i + "px" });
          }));
      },
    };
  })()),
  (function () {
    var e = $(".return-link");
    function t(e) {
      var t = document.createElement("a");
      return (t.ref = e), t.hostname;
    }
    document.referrer &&
      e.length &&
      window.history.length &&
      e.one("click", function (e) {
        e.preventDefault();
        var i = t(document.referrer);
        return t(window.location.href) === i && history.back(), !1;
      });
  })(),
  (theme.Slideshow = (function () {
    this.$slideshow = null;
    var e = {
      wrapper: "slideshow-wrapper",
      slideshow: "slideshow",
      currentSlide: "slick-current",
      video: "slideshow__video",
      videoBackground: "slideshow__video--background",
      closeVideoBtn: "slideshow__video-control--close",
      pauseButton: "slideshow__pause",
      isPaused: "is-paused",
    };
    function t(t) {
      (this.$slideshow = $(t)),
        (this.$wrapper = this.$slideshow.closest("." + e.wrapper)),
        (this.$pause = this.$wrapper.find("." + e.pauseButton)),
        (this.settings = {
          accessibility: !0,
          arrows: !1,
          dots: !0,
          fade: !0,
          draggable: !0,
          touchThreshold: 20,
          autoplay: this.$slideshow.data("autoplay"),
          autoplaySpeed: this.$slideshow.data("speed"),
        }),
        this.$slideshow.on("beforeChange", s.bind(this)),
        this.$slideshow.on("init", i.bind(this)),
        this.$slideshow.slick(this.settings),
        this.$pause.on("click", this.togglePause.bind(this));
    }
    function i(t, i) {
      var s = i.$slider,
        a = i.$list,
        o = this.$wrapper,
        n = this.settings.autoplay;
      a.removeAttr("aria-live"),
        o.on("focusin", function (e) {
          o.has(e.target).length &&
            (a.attr("aria-live", "polite"), n && s.slick("slickPause"));
        }),
        o.on("focusout", function (t) {
          if (o.has(t.target).length && (a.removeAttr("aria-live"), n)) {
            if (!$(t.target).hasClass(e.closeVideoBtn)) s.slick("slickPlay");
          }
        }),
        i.$dots &&
          i.$dots.on("keydown", function (e) {
            37 === e.which && s.slick("slickPrev"),
              39 === e.which && s.slick("slickNext"),
              (37 === e.which || 39 === e.which) &&
                i.$dots.find(".slick-active button").focus();
          });
    }
    function s(t, i, s, o) {
      var n = i.$slider,
        r = n.find("." + e.currentSlide),
        c = n.find('.slideshow__slide[data-slick-index="' + o + '"]');
      if (a(r)) {
        var d = r.find("." + e.video),
          l = d.attr("id");
        theme.SlideshowVideo.pauseVideo(l), d.attr("tabindex", "-1");
      }
      if (a(c)) {
        var u = c.find("." + e.video),
          h = u.attr("id");
        u.hasClass(e.videoBackground)
          ? theme.SlideshowVideo.playVideo(h)
          : u.attr("tabindex", "0");
      }
    }
    function a(t) {
      return t.find("." + e.video).length;
    }
    return (
      (t.prototype.togglePause = function () {
        var t,
          i = ((t = this.$pause), "#Slideshow-" + t.data("id"));
        this.$pause.hasClass(e.isPaused)
          ? (this.$pause.removeClass(e.isPaused), $(i).slick("slickPlay"))
          : (this.$pause.addClass(e.isPaused), $(i).slick("slickPause"));
      }),
      t
    );
  })()),
  (theme.SlideshowVideo = (function () {
    var e = !1,
      t = !1,
      i = !1,
      s = !1,
      a = !1,
      o = {},
      n = [],
      r = {
        ratio: 16 / 9,
        playerVars: {
          iv_load_policy: 3,
          modestbranding: 1,
          autoplay: 0,
          controls: 0,
          showinfo: 0,
          wmode: "opaque",
          branding: 0,
          autohide: 0,
          rel: 0,
        },
        events: {
          onReady: function e(t) {
            t.target.setPlaybackQuality("hd1080");
            var a = g(t);
            switch (
              (!i &&
                (750 > $(window).width()
                  ? (s = !0)
                  : window.mobileCheck() && (s = !0),
                s && l(!1),
                (i = !0)),
              $("#" + a.id).attr("tabindex", "-1"),
              v(),
              a.type)
            ) {
              case "background-chrome":
              case "background":
                t.target.mute(),
                  a.$parentSlide.hasClass(c.currentSlide) && d(a.id);
            }
            a.$parentSlide.addClass(c.loaded);
          },
          onStateChange: function e(t) {
            var i = g(t);
            switch (t.data) {
              case 0:
                (function e(t) {
                  switch (t.type) {
                    case "background":
                      n[t.id].seekTo(0);
                      break;
                    case "background-chrome":
                      n[t.id].seekTo(0), p(t.id);
                      break;
                    case "chrome":
                      p(t.id);
                  }
                })(i);
                break;
              case 1:
                u(i);
                break;
              case 2:
                h(i);
            }
          },
        },
      },
      c = {
        playing: "video-is-playing",
        paused: "video-is-paused",
        loading: "video-is-loading",
        loaded: "video-is-loaded",
        slideshowWrapper: "slideshow-wrapper",
        slide: "slideshow__slide",
        slideBackgroundVideo: "slideshow__slide--background-video",
        slideDots: "slick-dots",
        videoChrome: "slideshow__video--chrome",
        videoBackground: "slideshow__video--background",
        playVideoBtn: "slideshow__video-control--play",
        closeVideoBtn: "slideshow__video-control--close",
        currentSlide: "slick-current",
        slickClone: "slick-cloned",
        supportsAutoplay: "autoplay",
        supportsNoAutoplay: "no-autoplay",
      };
    function d(i, a) {
      var r,
        d,
        h,
        p,
        g,
        v,
        f = o[i],
        m = n[i],
        b = o[i].$parentSlide;
      if (s) u(f);
      else if (a || (e && t)) {
        b.removeClass(c.loading), u(f), m.playVideo();
        return;
      }
      e ||
        ((r = m),
        (d = b),
        r.playVideo(),
        ((h = r),
        (v = $.Deferred()),
        (p = setInterval(function () {
          !(0 >= h.getCurrentTime()) &&
            ((t = !0), clearInterval(p), clearTimeout(g), v.resolve());
        }, 500)),
        (g = setTimeout(function () {
          clearInterval(p), v.reject();
        }, 4e3)),
        v)
          .then(function () {
            l(!0);
          })
          .fail(function () {
            l(!1), r.stopVideo();
          })
          .always(function () {
            (e = !0), d.removeClass(c.loading);
          }));
    }
    function l(t) {
      var i = t ? c.supportsAutoplay : c.supportsNoAutoplay;
      $(document.documentElement).addClass(i), t || (s = !0), (e = !0);
    }
    function u(e) {
      var t = e.$parentSlideshowWrapper,
        i = e.$parentSlide;
      if ((i.removeClass(c.loading), "background" !== e.status)) {
        switch (($("#" + e.id).attr("tabindex", "0"), e.type)) {
          case "chrome":
          case "background-chrome":
            t.removeClass(c.paused).addClass(c.playing),
              i.removeClass(c.paused).addClass(c.playing);
        }
        i.find("." + c.closeVideoBtn).focus();
      }
    }
    function h(e) {
      var t = e.$parentSlideshowWrapper,
        i = e.$parentSlide;
      if ("background-chrome" === e.type) {
        p(e.id);
        return;
      }
      "closed" !== e.status &&
        "background" !== e.type &&
        (t.addClass(c.paused), i.addClass(c.paused)),
        "chrome" === e.type &&
          "closed" === e.status &&
          (t.removeClass(c.paused), i.removeClass(c.paused)),
        t.removeClass(c.playing),
        i.removeClass(c.playing);
    }
    function p(e) {
      var t,
        i,
        s = o[e],
        a = s.$parentSlideshowWrapper,
        r = s.$parentSlide,
        d = [c.pause, c.playing].join(" ");
      switch (
        ($("#" + s.id).attr("tabindex", "-1"), (s.status = "closed"), s.type)
      ) {
        case "background-chrome":
          n[e].mute(),
            (i = $("#" + (t = e))
              .addClass(c.videoBackground)
              .removeClass(c.videoChrome)),
            o[t].$parentSlide.addClass(c.slideBackgroundVideo),
            (o[t].status = "background"),
            f(i);
          break;
        case "chrome":
          n[e].stopVideo(), h(s);
      }
      a.removeClass(d), r.removeClass(d);
    }
    function g(e) {
      return o[e.target.h.id];
    }
    function v() {
      $("." + c.videoBackground).each(function (e, t) {
        f($(t));
      });
    }
    function f(e) {
      var t = e.closest("." + c.slide);
      if (!t.hasClass(c.slickClone)) {
        var i = t.width(),
          s = e.width(),
          a = e.height();
        i / r.ratio < a
          ? ((s = Math.ceil(a * r.ratio)),
            e
              .width(s)
              .height(a)
              .css({ left: (i - s) / 2, top: 0 }))
          : ((a = Math.ceil(i / r.ratio)),
            e
              .width(i)
              .height(a)
              .css({ left: 0, top: (a - a) / 2 })),
          e.prepareTransition().addClass(c.loaded);
      }
    }
    function m() {
      $(document).on("click.videoPlayer", "." + c.playVideoBtn, function (e) {
        !(function e(t) {
          var i,
            s = o[t];
          switch (
            (s.$parentSlide.addClass(c.loading), (s.status = "open"), s.type)
          ) {
            case "background-chrome":
              $("#" + (i = t))
                .removeAttr("style")
                .removeClass(c.videoBackground)
                .addClass(c.videoChrome),
                o[i].$parentSlideshowWrapper
                  .removeClass(c.slideBackgroundVideo)
                  .addClass(c.playing),
                o[i].$parentSlide
                  .removeClass(c.slideBackgroundVideo)
                  .addClass(c.playing),
                (o[i].status = "open"),
                n[t].unMute(),
                d(t, !0);
              break;
            case "chrome":
              d(t, !0);
          }
          $(document).on("keydown.videoPlayer", function (e) {
            27 === e.keyCode && p(t);
          });
        })($(e.currentTarget).data("controls"));
      }),
        $(document).on(
          "click.videoPlayer",
          "." + c.closeVideoBtn,
          function (e) {
            p($(e.currentTarget).data("controls"));
          }
        ),
        $(window).on(
          "resize.videoPlayer",
          $.debounce(250, function () {
            a && v();
          })
        );
    }
    return {
      init: function e(t) {
        if (
          t.length &&
          ((o[t.attr("id")] = {
            id: t.attr("id"),
            videoId: t.data("id"),
            type: t.data("type"),
            status: "chrome" === t.data("type") ? "closed" : "background",
            videoSelector: t.attr("id"),
            $parentSlide: t.closest("." + c.slide),
            $parentSlideshowWrapper: t.closest("." + c.slideshowWrapper),
            controls: "background" === t.data("type") ? 0 : 1,
            slideshow: t.data("slideshow"),
          }),
          !a)
        ) {
          var i = document.createElement("script");
          i.src = "https://www.youtube.com/iframe_api";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(i, s);
        }
      },
      loadVideos: function e() {
        for (var t in o)
          if (o.hasOwnProperty(t)) {
            var i = $.extend({}, r, o[t]);
            (i.playerVars.controls = i.controls), (n[t] = new YT.Player(t, i));
          }
        m(), (a = !0);
      },
      loadVideo: function e(t) {
        if (a) {
          var i = $.extend({}, r, o[t]);
          (i.playerVars.controls = i.controls),
            (n[t] = new YT.Player(t, i)),
            m();
        }
      },
      playVideo: function e(t) {
        (i || s) && t && "function" == typeof n[t].playVideo && d(t);
      },
      pauseVideo: function e(t) {
        n[t] && "function" == typeof n[t].pauseVideo && n[t].pauseVideo();
      },
      removeEvents: function e() {
        $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
      },
    };
  })()),
  (function () {
    var e = $("#BlogTagFilter");
    e.length &&
      e.on("change", function () {
        location.href = $(this).val();
      });
  })(),
  (window.theme = theme || {}),
  (theme.customerTemplates = (function () {
    function e() {
      $("#RecoverPasswordForm").toggleClass("hide"),
        $("#CustomerLoginForm").toggleClass("hide");
    }
    return {
      init: function () {
        var t;
        "#recover" === window.location.hash && e(),
          $("#RecoverPassword").on("click", function (t) {
            t.preventDefault(), e();
          }),
          $("#HideRecoverPasswordLink").on("click", function (t) {
            t.preventDefault(), e();
          }),
          $(".reset-password-success").length &&
            $("#ResetSuccess").removeClass("hide"),
          (t = $("#AddressNewForm")),
          t.length &&
            (Shopify &&
              new Shopify.CountryProvinceSelector(
                "AddressCountryNew",
                "AddressProvinceNew",
                { hideElement: "AddressProvinceContainerNew" }
              ),
            $(".address-country-option").each(function () {
              var e = $(this).data("form-id");
              new Shopify.CountryProvinceSelector(
                "AddressCountry_" + e,
                "AddressProvince_" + e,
                { hideElement: "AddressProvinceContainer_" + e }
              );
            }),
            $(".address-new-toggle").on("click", function () {
              t.toggleClass("hide");
            }),
            $(".address-edit-toggle").on("click", function () {
              var e = $(this).data("form-id");
              $("#EditAddress_" + e).toggleClass("hide");
            }),
            $(".address-delete").on("click", function () {
              var e = $(this),
                t = e.data("form-id");
              confirm(
                e.data("confirm-message") ||
                  "Are you sure you wish to delete this address?"
              ) &&
                Shopify.postLink("/account/addresses/" + t, {
                  parameters: { _method: "delete" },
                });
            }));
      },
    };
  })()),
  (window.theme = window.theme || {}),
  (theme.Cart = (function () {
    var e = { edit: ".js-edit-toggle" },
      t = {
        showClass: "cart__update--show",
        showEditClass: "cart__edit--active",
      };
    function i(t) {
      (this.$container = $(t)),
        (this.$edit = $(e.edit, this.$container)),
        this.$edit.on("click", this._onEditClick.bind(this));
    }
    return (
      (i.prototype = lodash.assignIn({}, i.prototype, {
        onUnload: function () {
          this.$edit.off("click", this._onEditClick);
        },
        _onEditClick: function (e) {
          var i = $(e.target),
            s = $("." + i.data("target"));
          i.toggleClass(t.showEditClass), s.toggleClass(t.showClass);
        },
      })),
      i
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Filters = (function () {
    var e = { SORT_BY: "sort_by" },
      t = {
        filterSelection: ".filters-toolbar__input--filter",
        sortSelection: ".filters-toolbar__input--sort",
        defaultSort: ".collection-header__default-sort",
      };
    function i(e) {
      var i = (this.$container = $(e));
      (this.$filterSelect = $(t.filterSelection, i)),
        (this.$sortSelect = $(t.sortSelection, i)),
        (this.$selects = $(t.filterSelection, i).add($(t.sortSelection, i))),
        (this.defaultSort = this._getDefaultSortValue()),
        this._resizeSelect(this.$selects),
        this.$selects.removeClass("hidden"),
        this.$filterSelect.on("change", this._onFilterChange.bind(this)),
        this.$sortSelect.on("change", this._onSortChange.bind(this));
    }
    return (
      (i.prototype = lodash.assignIn({}, i.prototype, {
        _onSortChange: function (e) {
          var t = this._sortValue();
          t.length
            ? (window.location.search = t)
            : (window.location.href = window.location.href.replace(
                window.location.search,
                ""
              )),
            this._resizeSelect($(e.target));
        },
        _onFilterChange: function (e) {
          (window.location.href =
            this.$filterSelect.val() + window.location.search),
            this._resizeSelect($(e.target));
        },
        _getSortValue: function () {
          return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function () {
          return $(t.defaultSort, this.$container).val();
        },
        _sortValue: function () {
          var t = this._getSortValue(),
            i = "";
          return t !== this.defaultSort && (i = e.SORT_BY + "=" + t), i;
        },
        _resizeSelect: function (e) {
          e.each(function () {
            var e = $(this),
              t = e.find("option:selected").text(),
              i = $("<span>").html(t);
            i.appendTo("body");
            var s = i.width();
            i.remove(), e.width(s + 10);
          });
        },
        onUnload: function () {
          this.$filterSelect.off("change", this._onFilterChange),
            this.$sortSelect.off("change", this._onSortChange);
        },
      })),
      i
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.HeaderSection = (function () {
    function e() {
      theme.Header.init(), theme.MobileNav.init(), theme.Search.init();
    }
    return (
      (e.prototype = lodash.assignIn({}, e.prototype, {
        onUnload: function () {
          theme.Header.unload();
        },
      })),
      e
    );
  })()),
  (theme.Maps = (function () {
    var e = { zoom: 14 },
      t = null,
      i = [],
      s = theme.mapKey ? theme.mapKey : "";
    function a(e) {
      (this.$container = $(e)),
        "loaded" === t
          ? this.createMap()
          : (i.push(this),
            "loading" !== t &&
              ((t = "loading"),
              void 0 === window.google &&
                $.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" + s
                ).then(function () {
                  (t = "loaded"),
                    $.each(i, function (e, t) {
                      t.createMap();
                    });
                })));
    }
    return (
      (a.prototype = lodash.assignIn({}, a.prototype, {
        createMap: function () {
          var t,
            i,
            s,
            a,
            o = this.$container.find(".map-section__container");
          return ((t = o),
          (i = $.Deferred()),
          (s = new google.maps.Geocoder()),
          (a = t.data("address-setting")),
          s.geocode({ address: a }, function (e, t) {
            t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
          }),
          i)
            .then(
              function (t) {
                var i = {
                    zoom: e.zoom,
                    center: t[0].geometry.location,
                    disableDefaultUI: !0,
                  },
                  s = (this.map = new google.maps.Map(o[0], i)),
                  a = (this.center = s.getCenter());
                new google.maps.Marker({ map: s, position: s.getCenter() }),
                  google.maps.event.addDomListener(
                    window,
                    "resize",
                    $.debounce(250, function () {
                      google.maps.event.trigger(s, "resize"), s.setCenter(a);
                    })
                  );
              }.bind(this)
            )
            .fail(function () {
              var e;
              switch (status) {
                case "ZERO_RESULTS":
                  e = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  e = theme.strings.addressQueryLimit;
                  break;
                default:
                  e = theme.strings.addressError;
              }
              o.parent()
                .addClass("page-width map-section--load-error")
                .html('<div class="errors text-center">' + e + "</div>");
            });
        },
        onUnload: function () {
          google.maps.event.clearListeners(this.map, "resize");
        },
      })),
      a
    );
  })()),
  (theme.Product = (function () {
    function e(e) {
      var t = (this.$container = $(e)),
        i = t.attr("data-section-id");
      (this.settings = {
        mediaQueryMediumUp: "screen and (min-width: 750px)",
        mediaQuerySmall: "screen and (max-width: 749px)",
        bpSmall: !1,
        enableHistoryState: t.data("enable-history-state") || !1,
        imageSize: null,
        imageZoomSize: null,
        namespace: ".slideshow-" + i,
        sectionId: i,
        sliderActive: !1,
        zoomEnabled: !1,
      }),
        (this.selectors = {
          addToCart: "#AddToCart-" + i,
          addToCartText: "#AddToCartText-" + i,
          comparePrice: "#ComparePrice-" + i,
          originalPrice: "#ProductPrice-" + i,
          SKU: ".variant-sku",
          originalPriceWrapper: ".product-price__price-" + i,
          originalSelectorId: "#ProductSelect-" + i,
          productFeaturedImage: ".product-single-image-0-" + i,
          productImageWrap: "#FeaturedImageZoom-" + i,
          productPrices: ".product-single__price-" + i,
          productThumbImages: ".product-single__thumbnail--" + i,
          productThumbs: ".product-single__thumbnails-" + i,
          saleClasses: "product-price__sale product-price__sale--single",
          saleLabel: ".product-price__sale-label-" + i,
          singleOptionSelector: ".single-option-selector-" + i,
        }),
        $("#ProductJson-" + i).html() &&
          ((this.productSingleObject = JSON.parse(
            document.getElementById("ProductJson-" + i).innerHTML
          )),
          (this.settings.zoomEnabled = $(
            this.selectors.productFeaturedImage
          ).hasClass("js-zoom-enabled")),
          (this.settings.imageSize = theme.Images.imageSize(
            $(this.selectors.productFeaturedImage).attr("src")
          )),
          this.settings.zoomEnabled &&
            (this.settings.imageZoomSize = theme.Images.imageSize(
              $(this.selectors.productImageWrap).data("zoom")
            )),
          this._initBreakpoints(),
          this._stringOverrides(),
          this._initVariants(),
          this._initImageSwitch(),
          this._setActiveThumbnail(),
          theme.Images.preload(
            this.productSingleObject.images,
            this.settings.imageSize
          ));
    }
    function t(e) {
      var t = e.data("zoom");
      e.zoom({ url: t });
    }
    function i(e) {
      e.trigger("zoom.destroy");
    }
    return (
      (e.prototype = lodash.assignIn({}, e.prototype, {
        _stringOverrides: function () {
          (theme.productStrings = theme.productStrings || {}),
            $.extend(theme.strings, theme.productStrings);
        },
        _initBreakpoints: function () {
          var e = this;
          enquire.register(this.settings.mediaQuerySmall, {
            match: function () {
              $(e.selectors.productThumbImages).length > 3 &&
                e._initThumbnailSlider(),
                e.settings.zoomEnabled && i($(e.selectors.productImageWrap)),
                (e.settings.bpSmall = !0);
            },
            unmatch: function () {
              e.settings.sliderActive && e._destroyThumbnailSlider(),
                (e.settings.bpSmall = !1);
            },
          }),
            enquire.register(this.settings.mediaQueryMediumUp, {
              match: function () {
                e.settings.zoomEnabled && t($(e.selectors.productImageWrap));
              },
            });
        },
        _initVariants: function () {
          var e = {
            $container: this.$container,
            enableHistoryState:
              this.$container.data("enable-history-state") || !1,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject,
          };
          (this.variants = new slate.Variants(e)),
            this.$container.on(
              "variantChange" + this.settings.namespace,
              this._updateAddToCart.bind(this)
            ),
            this.$container.on(
              "variantImageChange" + this.settings.namespace,
              this._updateImages.bind(this)
            ),
            this.$container.on(
              "variantPriceChange" + this.settings.namespace,
              this._updatePrice.bind(this)
            ),
            this.$container.on(
              "variantSKUChange" + this.settings.namespace,
              this._updateSKU.bind(this)
            );
        },
        _initImageSwitch: function () {
          if ($(this.selectors.productThumbImages).length) {
            var e = this;
            $(this.selectors.productThumbImages).on("click", function (t) {
              t.preventDefault();
              var i = $(this),
                s = i.attr("href"),
                a = i.data("zoom");
              e._switchImage(s, a), e._setActiveThumbnail(s);
            });
          }
        },
        _setActiveThumbnail: function (e) {
          var t = "active-thumb";
          void 0 === e &&
            (e = $(this.selectors.productFeaturedImage).attr("src"));
          var i = $(this.selectors.productThumbImages + '[href="' + e + '"]');
          $(this.selectors.productThumbImages).removeClass(t), i.addClass(t);
        },
        _switchImage: function (e, s) {
          $(this.selectors.productFeaturedImage).attr("src", e),
            this.settings.zoomEnabled && i($(this.selectors.productImageWrap)),
            !this.settings.bpSmall &&
              this.settings.zoomEnabled &&
              s &&
              ($(this.selectors.productImageWrap).data("zoom", s),
              t($(this.selectors.productImageWrap)));
        },
        _initThumbnailSlider: function () {
          var e = {
            slidesToShow: 4,
            slidesToScroll: 3,
            infinite: !1,
            prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
            nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
            responsive: [{ breakpoint: 321, settings: { slidesToShow: 3 } }],
          };
          $(this.selectors.productThumbs).slick(e),
            (this.settings.sliderActive = !0);
        },
        _destroyThumbnailSlider: function () {
          $(this.selectors.productThumbs).slick("unslick"),
            (this.settings.sliderActive = !1);
        },
        _updateAddToCart: function (e) {
          var t = e.variant;
          t
            ? ($(".product-form__variants").attr("data-id", t.id),
              $(this.selectors.productPrices)
                .removeClass("visibility-hidden")
                .attr("aria-hidden", "true"),
              t.available
                ? ($(this.selectors.addToCart).prop("disabled", !1),
                  $(this.selectors.addToCartText).text(theme.strings.addToCart))
                : ($(this.selectors.addToCart).prop("disabled", !0),
                  $(this.selectors.addToCartText).text(theme.strings.soldOut)))
            : ($(this.selectors.addToCart).prop("disabled", !0),
              $(this.selectors.addToCartText).text(theme.strings.unavailable),
              $(this.selectors.productPrices)
                .addClass("visibility-hidden")
                .attr("aria-hidden", "false"));
        },
        _updateImages: function (e) {
          var t,
            i = e.variant,
            s = theme.Images.getSizedImageUrl(
              i.featured_image.src,
              this.settings.imageSize
            );
          this.settings.zoomEnabled &&
            (t = theme.Images.getSizedImageUrl(
              i.featured_image.src,
              this.settings.imageZoomSize
            )),
            this._switchImage(s, t),
            this._setActiveThumbnail(s);
        },
        _updatePrice: function (e) {
          var t = e.variant;
          $(this.selectors.originalPrice).html(
            theme.Currency.formatMoney(t.price, theme.moneyFormat)
          ),
            t.compare_at_price > t.price
              ? ($(this.selectors.comparePrice)
                  .html(
                    theme.Currency.formatMoney(
                      t.compare_at_price,
                      theme.moneyFormat
                    )
                  )
                  .removeClass("hide"),
                $(this.selectors.originalPriceWrapper).addClass(
                  this.selectors.saleClasses
                ),
                $(this.selectors.saleLabel).removeClass("hide"))
              : ($(this.selectors.comparePrice).addClass("hide"),
                $(this.selectors.saleLabel).addClass("hide"),
                $(this.selectors.originalPriceWrapper).removeClass(
                  this.selectors.saleClasses
                ));
        },
        _updateSKU: function (e) {
          var t = e.variant;
          $(this.selectors.SKU).html(t.sku);
        },
        onUnload: function () {
          this.$container.off(this.settings.namespace);
        },
      })),
      e
    );
  })()),
  (theme.Quotes = (function () {
    var e = {
        mediaQuerySmall: "screen and (max-width: 749px)",
        mediaQueryMediumUp: "screen and (min-width: 750px)",
        slideCount: 0,
      },
      t = {
        accessibility: !0,
        arrows: !1,
        dots: !0,
        autoplay: !1,
        touchThreshold: 20,
        slidesToShow: 3,
        slidesToScroll: 3,
      };
    function i(i) {
      var s = (this.$container = $(i)).attr("data-section-id"),
        a = (this.wrapper = ".quotes-wrapper"),
        o = $((this.slider = "#Quotes-" + s), a),
        n = !1,
        r = $.extend({}, t, {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: !0,
        });
      function c(e, t) {
        n && (e.slick("unslick"), (n = !1)), e.slick(t), (n = !0);
      }
      (e.slideCount = o.data("count")),
        e.slideCount < t.slidesToShow &&
          ((t.slidesToShow = e.slideCount), (t.slidesToScroll = e.slideCount)),
        o.on("init", this.a11y.bind(this)),
        enquire.register(e.mediaQuerySmall, {
          match: function () {
            c(o, r);
          },
        }),
        enquire.register(e.mediaQueryMediumUp, {
          match: function () {
            c(o, t);
          },
        });
    }
    return (
      (i.prototype = lodash.assignIn({}, i.prototype, {
        onUnload: function () {
          enquire.unregister(e.mediaQuerySmall),
            enquire.unregister(e.mediaQueryMediumUp),
            $(this.slider, this.wrapper).slick("unslick");
        },
        onBlockSelect: function (e) {
          var t = $(
            ".quotes-slide--" + e.detail.blockId + ":not(.slick-cloned)"
          ).data("slick-index");
          $(this.slider, this.wrapper).slick("slickGoTo", t);
        },
        a11y: function (e, t) {
          var i = t.$list,
            s = $(this.wrapper, this.$container);
          i.removeAttr("aria-live"),
            s.on("focusin", function (e) {
              s.has(e.target).length && i.attr("aria-live", "polite");
            }),
            s.on("focusout", function (e) {
              s.has(e.target).length && i.removeAttr("aria-live");
            });
        },
      })),
      i
    );
  })()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = function e(t) {
    var i = (this.$container = $(t)).attr("data-section-id"),
      s = (this.slideshow = "#Slideshow-" + i);
    $(".slideshow__video", s).each(function () {
      var e = $(this);
      theme.SlideshowVideo.init(e),
        theme.SlideshowVideo.loadVideo(e.attr("id"));
    }),
      (theme.slideshows[s] = new theme.Slideshow(s));
  }),
  (theme.SlideshowSection.prototype = lodash.assignIn(
    {},
    theme.SlideshowSection.prototype,
    {
      onUnload: function () {
        delete theme.slideshows[this.slideshow];
      },
      onBlockSelect: function (e) {
        var t = $(this.slideshow),
          i = $(
            ".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)"
          ).data("slick-index");
        t.slick("slickGoTo", i).slick("slickPause");
      },
      onBlockDeselect: function () {
        $(this.slideshow).slick("slickPlay");
      },
    }
  )),
  $(document).ready(function () {
    var e = new theme.Sections();
    e.register("cart-template", theme.Cart),
      e.register("product", theme.Product),
      e.register("collection-template", theme.Filters),
      e.register("product-template", theme.Product),
      e.register("header-section", theme.HeaderSection),
      e.register("map", theme.Maps),
      e.register("slideshow-section", theme.SlideshowSection),
      e.register("quotes", theme.Quotes);
  }),
  (theme.init = function () {
    theme.customerTemplates.init(),
      slate.rte.wrapTable(),
      slate.rte.iframeReset(),
      slate.a11y.pageLinkFocus($(window.location.hash)),
      $(".in-page-link").on("click", function (e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash));
      }),
      $('a[href="#"]').on("click", function (e) {
        e.preventDefault();
      });
  }),
  $(theme.init);